// src/inspector/protocol/manager/to-client.ts
import { z } from "zod";
var ActorSchema = z.object({
  id: z.string(),
  name: z.string(),
  tags: z.record(z.string())
});
var ToClientSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("info"),
    actors: z.array(ActorSchema),
    types: z.array(z.string())
  }),
  z.object({
    type: z.literal("actors"),
    actors: z.array(ActorSchema)
  }),
  z.object({
    type: z.literal("error"),
    message: z.string()
  })
]);

// src/inspector/protocol/manager/to-server.ts
import { z as z2 } from "zod";
var ToServerSchema = z2.discriminatedUnion("type", [
  z2.object({
    type: z2.literal("info")
  }),
  z2.object({
    type: z2.literal("destroy"),
    actorId: z2.string()
  })
]);

export {
  ToClientSchema,
  ToServerSchema
};
//# sourceMappingURL=chunk-WAVRWHCC.js.map